module.exports = __webpack_public_path__ + "static/media/crossed-swords.b7d2c27a.svg";